<template>
  <View direction="column" gap="sm" class="coach-box">
    <View gap="sm" align="center" wrap="wrap">
      <Badge variant="grey" size="small" icon="lock-01" label="Coach Tallo" />
      <Text variant="body-small" color="secondary">
        Tallo learns your voice from this feedback. Never sent to the renter.
      </Text>
    </View>

    <Textarea v-model="comment" rows="2" resize="none" placeholder="I wouldn't have said that… / Next time, mention…" />

    <View justify="end">
      <Button variant="primary" size="small" :loading="isSubmitting" :disabled="!comment.trim()" @click="submit">
        Share with Tallo
      </Button>
    </View>
  </View>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Badge, Button, Text, Textarea, View } from '@tallo/design-system';

import { useSubmitConversationFeedbackMutation } from '../mutations/submit-conversation-feedback.mutation';

const props = defineProps<{ conversationId: string }>();

const comment = ref('');

const { mutateAsync: submitFeedback, isLoading: isSubmitting } = useSubmitConversationFeedbackMutation();

async function submit(): Promise<void> {
  const trimmed = comment.value.trim();

  if (!trimmed) {
    return;
  }

  try {
    await submitFeedback({ conversationId: props.conversationId, comment: trimmed });

    comment.value = '';
  } catch {
    // The mutation toasts the error; keep the text so it isn't lost.
  }
}
</script>

<style scoped lang="scss">
// `.modal-footer` applies `margin-inline-start: auto` to its last child, so the box has to claim the
// full width or it collapses to its content and hugs the right edge.
.coach-box {
  width: 100%;
}

.coach-box :deep(textarea) {
  width: 100%;
}
</style>
